import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import React from 'react';
import { styles } from './AccordianSection.styles';

export const AccordianSection = ({ children, title }: { children: React.ReactNode; title: string }) => {
  return (
    <Accordion variant="arrowAlignmentRight" defaultExpanded sx={styles.accordion}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={styles.expandIcon} />}
        aria-controls={`${title}-content`}
        id={`${title}-header`}
        onClick={(e) => {
          // blur the element after click so it doesn't stay focused
          (e.currentTarget as HTMLElement).blur();
        }}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails sx={styles.accordionDetails}>{children}</AccordionDetails>
    </Accordion>
  );
};
